// Modify these in order to build this website for a specific tenant. It is very
// barebones for now due to POC constraints

export const PROXY_HOST = process.env.REACT_APP_PROXY_HOST as string;
export const TENANT = process.env.REACT_APP_TENANT as string;

export const DEV_MODE = process.env.REACT_APP_DEV_MODE;
export const DEV_TOKEN = process.env.REACT_APP_DEV_TOKEN;

export const CASABLANCA_HOST = process.env.REACT_APP_CASABLANCA_HOST as string;
export const CASABLANCA_TOKEN = process.env.REACT_APP_CASABLANCA_TOKEN as string;
